import { styled } from '@frontend/theme';
import { Box as MUIBox } from '@mui/material';
import BaseIconButton from '../IconButton/IconButton';

export const CarouselWrapper = styled(MUIBox)<{
  height?: string;
  width?: string;
}>(({ theme, height, width }) => ({
  width: width ? width : '400px',
  height: height ? height : '250px',

  '& .swiper': {
    width: '100%',
    height: '100%',
  },

  '& .swiper-slide': {
    cursor: 'pointer',
  },

  '& .swiper-pagination-fraction': {
    position: 'absolute',
    bottom: 0,
    left: 'unset',
    right: '0px',
    display: 'flex',
    width: 'auto',
    height: 'auto',
    minWidth: '54px',
    minHeight: '44px',
    padding: '5px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
    flexShrink: 0,
    backgroundColor: theme.palette.neutral[50],
    fontSize: '16px',

    '& > span': {
      fontSize: '16px',
    },
  },
}));

export const ImageWrapper = styled(MUIBox)({
  display: 'flex',
  width: '100%',
  height: '100%',
  '& > img': {
    objectFit: 'cover',
    objectPosition: 'center',
    width: '100%',
    height: '100%',
    display: 'block',
  },
});

export const NavigationWrapper = styled(MUIBox)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  width: '100%',
  height: '100%',
});

export const NavigationButton = styled(BaseIconButton)(({ theme }) => ({
  position: 'absolute',
  zIndex: 1,
  display: 'flex',
  width: '20px',
  height: '20px',
  padding: '4px',
  alignItems: 'center',
  gap: '8px',
  flexShrink: 0,
  borderRadius: '10px',
  backgroundColor: theme.palette.common.white,

  '&:hover': {
    backgroundColor: theme.palette.common.white,
  },
  '& > svg > path': {
    fill: theme.palette.neutral[700],
  },
  '&.prev-slide': {
    left: '12px',
  },
  '&.next-slide': {
    right: '12px',
  },
  '&.swiper-button-disabled': {
    display: 'none',
  },
}));
